import GroundingWalk from '@/components/Exercises/GroundingWalk/GroundingWalk'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(content)/children/exercises/(shared)/grounding-walk/',
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "⁠Are you scared? - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "groundingWalk.title",
    navbar: {
      showTitle: true,
    },
  }),
})

function RouteComponent() {
  return <GroundingWalk />
}
